import React from "react";
import BackButton from "../components/BackButton";
import VideoFrame from "../assets/video_frame.png";
import ButtonList from "../components/ButtonList";
import Logo from "../assets/isuzu_truck_logo.png";
import { useNavigate } from "react-router-dom";

const DemoVideoPage = ({ videoData }) => {
  const navigate = useNavigate();
  return (
    <div className="d-flex justify-content-center align-items-center h-100 w-100 position-relative">
      <BackButton onClickHandler={navigate("/")}/>
      <div className="col-4 d-flex align-items-center h-100">
        <ButtonList
            items={videoData.map((videoTitlePair) => videoTitlePair.title)}
            screen={"demovideo"}
        />
      </div>
      <div className="col-8 video-frame-container">
        <img src={VideoFrame} className="video-frame" />
        <img src={Logo} alt="Isuzu Truck Logo" className="logo" />
      </div>
    </div>
  );
};

export default DemoVideoPage;
